import { render, staticRenderFns } from "./assignEditor.vue?vue&type=template&id=70359be7"
import script from "./assignEditor.vue?vue&type=script&lang=js"
export * from "./assignEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports